import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomePage } from './pages/home-page/home-page.component';
import { ModulosResolver } from './resolvers/modulos.resolver'; 
import { SistemaDeGestaoPage } from './pages/servicos/sistema-de-gestao-page/sistema-de-gestao-page.component';
import { EcommercePage } from './pages/servicos/ecommerce-page/ecommerce-page.component';
import { AplicativoPage } from './pages/servicos/aplicativo-page/aplicativo-page.component';
import { DashboardPage } from './pages/servicos/dashboard-page/dashboard-page.component';
import { ContatoPage } from './pages/contato-page/contato-page.component';
import { SobrePage } from './pages/sobre-page/sobre-page.component';
import { SejaNossoParceiroPage } from './pages/seja-nosso-parceiro-page/seja-nosso-parceiro-page.component';
import { ServicosPage } from './pages/servicos/servicos-page/servicos-page.component';
import { DizimoOfertaPageComponent } from './pages/dizimo-oferta-page/dizimo-oferta-page.component';
import { ConexoesPageComponent } from './pages/conexoes-page/conexoes-page.component';
import { LiderancaPageComponent } from './pages/lideranca-page/lideranca-page.component';
import { GreenhouseSchoolPageComponent } from './pages/greenhouse-school-page/greenhouse-school-page.component';
import { AgendaPageComponent } from './pages/agenda-page/agenda-page.component';
import { JejumColetivoPageComponent } from './pages/jejum-coletivo-page/jejum-coletivo-page.component';
import { EventoPageComponent } from './pages/evento/evento-page/evento-page.component';
import { NegocioPageComponent } from './pages/negocio/negocio-page/negocio-page.component';

const routes: Routes = [{
  path: '',   
  component: HomePage,
  resolve:{   
    modulos: ModulosResolver
  }  
},{
  path: 'contato',   
  component: ContatoPage, 
  resolve:{   
    modulos: ModulosResolver
  }  
},{
  path: 'dizimos-e-ofertas',   
  component: DizimoOfertaPageComponent, 
  resolve:{   
    modulos: ModulosResolver
  }  
},{
  path: 'sobre', 
  component: SobrePage,  
  resolve:{   
    modulos: ModulosResolver 
  }  
},{
  path: 'conexoes', 
  component: ConexoesPageComponent,  
  resolve:{   
    modulos: ModulosResolver 
  }  
},{
  path: 'jejum-coletivo', 
  component: JejumColetivoPageComponent,  
  resolve:{   
    modulos: ModulosResolver 
  }  
},{
  path: 'quem-somos/conheca-a-nossa-igreja', 
  component: SobrePage,  
  resolve:{   
    modulos: ModulosResolver 
  }  
},{
  path: 'quem-somos/lideranca', 
  component: LiderancaPageComponent,  
  resolve:{   
    modulos: ModulosResolver 
  }  
},{
  path: 'greenhouse-school',   
  component: GreenhouseSchoolPageComponent,  
  resolve:{   
    modulos: ModulosResolver 
  }  
},{
  path: 'agenda',   
  component: AgendaPageComponent,  
  resolve:{   
    modulos: ModulosResolver 
  }  
},{
  path: 'evento/:apelido',   
  component: EventoPageComponent,  
  resolve:{   
    modulos: ModulosResolver 
  }  
},{
  path: 'negocios', 
  component: NegocioPageComponent,  
  resolve:{   
    modulos: ModulosResolver 
  }  
},{
  path: 'negocios/:token', 
  component: NegocioPageComponent,  
  resolve:{   
    modulos: ModulosResolver 
  }  
},{
  path: '**',
  pathMatch: 'full', 
  redirectTo: ''
}];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
